var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { styled, TextField as MuiTextField } from '@mui/material';
import React from 'react';
import { gray20, gray40opacity40, gray80 } from '../../colors/gray';
import { neutral60opacity20 } from '../../colors/neutral';
import { isLightTheme } from '../../utils/utils';
import { rem } from '../../utils/rem';
var getEncodedColor = function (theme) {
    var res = isLightTheme(theme) ? gray80 : gray20;
    return res.toString().replace('#', '%23');
};
var SMuiTextField = styled(MuiTextField)(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiInputBase-multiline': {
            padding: 0,
        },
        '& .MuiInputBase-inputMultiline': {
            margin: rem(2),
            lineHeight: rem(20),
            padding: "".concat(theme.spacing(1), " ").concat(theme.spacing(1.5)),
            resize: 'vertical',
        },
        '& input[type="search"]::-webkit-search-cancel-button': {
            /* Remove default */
            WebkitAppearance: 'none',
            appearance: 'none',
            width: rem(30),
            height: rem(30),
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'%3E%3Cpath id='close_12' d='M9.923 1 6 4.923 2.077 1 1 2.077 4.923 6 1 9.923 2.077 11 6 7.077 9.923 11 11 9.923 7.077 6 11 2.077Z' transform='translate(-1 -1)' fill='".concat(getEncodedColor(theme), "'/%3E%3C/svg%3E\")"),
            borderRadius: rem(3),
            cursor: 'pointer',
            transform: "translateX(".concat(rem(16), ")"),
        },
        '& input[type="search"]::-webkit-search-cancel-button:hover': {
            backgroundColor: isLightTheme(theme) ? neutral60opacity20 : gray40opacity40,
        },
    });
});
var TextField = function (_a) {
    var _b = _a.textAlign, textAlign = _b === void 0 ? 'left' : _b, inputProps = _a.inputProps, props = __rest(_a, ["textAlign", "inputProps"]);
    return (React.createElement(SMuiTextField, __assign({ inputProps: __assign({ style: __assign({}, (textAlign === 'right' && { textAlign: 'right' })) }, inputProps) }, props)));
};
export default TextField;
